import React from 'react';
import LinearProgress from '@mui/material/LinearProgress';
import { makeStyles, withStyles } from '@mui/styles';
import { Tooltip } from '@mui/material';

const useStyles = makeStyles((theme) => ({
    root: { flexGrow: 1 },
    colorPrimary: { background: 'transparent' }
}));

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: theme.palette.text.primary,
        boxShadow: theme.shadows[1],
        fontSize: 11
    }
}))(Tooltip);

const LinearProgressBar = (props) => {
    const {
        progressColor='#AD509E', tooltipText, value=50, bgColor = false 
    } = props;
    const classes = useStyles();

    return (
        <LightTooltip arrow placement="top" title={tooltipText}>
            <LinearProgress
                className={bgColor ?'bg-primary-50' : classes.colorPrimary}
                sx={{
                    height: '4px',
                    borderRadius: '4px',
                    '& .MuiLinearProgress-bar': { backgroundColor: progressColor },
                    '& .MuiLinearProgress-root': { backgroundColor: '#F9FAFB  !important' }
                }}
                value={Number(value)}
                variant="determinate"
            />
        </LightTooltip>
       
    );
};

export default LinearProgressBar;
